import React, { Component } from "react";
import { connect } from "react-redux";
import { View, Image } from "react-native";

import { Background, Card, NavButton } from "components";

import { styles } from "./styles";

class CommonLayout extends Component {
  render = () => {
    const { background, logo } = this.props;
    const { prev, next, nextDisabled } = this.props;

    return (
      <Background style={styles.background} image={background}>
        <Card style={styles.card}>
          <View
            style={styles.headerContainer}
            onLayout={() => this.forceUpdate()}
          >
            <Image
              source={{ uri: logo || null }}
              style={styles.logo}
              resizeMode="contain"
            />
          </View>
          {this.props.children}
          <View style={styles.footerContainer} />
        </Card>
        {prev && <NavButton left onPress={prev} />}
        {next && <NavButton right disabled={nextDisabled} onPress={next} />}
      </Background>
    );
  };
}

const mapStateToProps = state => {
  return {
    background: state.organization.background || "",
    logo: state.organization.logo || "",
  };
};

export default connect(mapStateToProps)(CommonLayout);
